import { palette } from '@livable/saas-react-components';
const MuiIconButton = {
  styleOverrides: {
    root: {
      color: palette.shades[700]
    },
    edgeEnd: {
      marginRight: '-6px'
    },
    sizeSmall: {
      padding: '0',
      '& .MuiSvgIcon-root': {
        width: '16px',
        height: '16px'
      }
    },
    sizeLarge: {
      padding: '0',
      '.MuiSvgIcon-root': {
        width: '32px',
        height: '32px'
      }
    }
  },
  variants: [{
    props: {
      variant: 'actionIcon'
    },
    style: {
      padding: '0',
      marginLeft: '5px'
    }
  }, {
    props: {
      variant: 'closeTabAction'
    },
    style: {
      padding: '0',
      marginLeft: '10px !important'
    }
  }, {
    props: {
      variant: 'profile'
    },
    style: {
      borderRadius: '0',
      padding: '10px',
      background: palette.gradients.white,
      '.MuiSvgIcon-root': {
        fontSize: '24px'
      },
      '&:hover': {
        background: palette.gradients.white,
        '.MuiSvgIcon-root path': {
          fill: palette.shades[800]
        }
      },
      '&[aria-expanded=true]': {
        background: palette.shades[300],
        '.MuiSvgIcon-root path': {
          fill: palette.shades[800]
        }
      },
      '&.Mui-focusVisible': {
        '.MuiSvgIcon-root path': {
          fill: palette.shades[800]
        }
      }
    }
  }, {
    props: {
      variant: 'notification'
    },
    style: {
      borderRadius: '0',
      padding: '18px',
      '.MuiSvgIcon-root': {
        zIndex: '1'
      },
      '&:before': {
        content: "''",
        background: palette.gradients.white,
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        width: '100%',
        height: '100%',
        opacity: '0',
        transition: "opacity ".concat(palette.transitions.short)
      },
      '&:hover': {
        background: 'none',
        '&:before': {
          opacity: '1'
        },
        '.MuiSvgIcon-root path': {
          fill: palette.shades[800]
        }
      },
      '&.Mui-focusVisible': {
        '&:before': {
          opacity: '1'
        },
        '.MuiSvgIcon-root path': {
          fill: palette.shades[800]
        }
      }
    }
  }]
};
export default MuiIconButton;